
import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LandingAccessComponent }    from './landing-access.component';

const PARAMETRO_ROUTES: Routes = [
  { path: 'landingAccess', component: LandingAccessComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(PARAMETRO_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class LandingAccessRoutingModule {}
